import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { store } from 'store';
import { TranslatorProvider } from 'utils/translator';
import Header from 'sections/header';
import GlobalError from 'components/globalError';
import { useIdleRedirect } from 'utils/hooks';

import router from 'router';

import 'assets/scss/style.scss';

const AppContent = () => {
  useIdleRedirect();

  return (
    <>
      <Header />
      <GlobalError />
      <main>
        <Routes>
          {router.map(({ Component, path }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
        </Routes>
      </main>
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <TranslatorProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </TranslatorProvider>
    </Provider>
  );
}

export default App;
